import React__default from 'react';

const root = "_root_mz469_1";
const closeButton = "_close-button_mz469_24";
const styles = {
	root: root,
	closeButton: closeButton
};

const ModalMediaContent = (props) => {
  return React__default.createElement(
    "div",
    { className: styles.root, "data-zds": true },
    props.children,
    props.closeButton && React__default.createElement("div", { className: styles.closeButton, "data-zds": true }, props.closeButton)
  );
};

export { ModalMediaContent };
//# sourceMappingURL=ModalMediaContent.es.js.map
